import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCategoriesAsync } from '../../actions/category.action';
import { getCompaniesAsync } from '../../actions/company.action';
import CompaniesResults from '../../components/CompaniesResults';
import CompaniesSearch from '../../components/CompaniesSearch';
import Footer from '../../components/Footer';
import StickyHeader from '../../components/StickyHeader';
import useQuery from '../../utils/useQuery';

function CompaniesListing() {
  const dispatch = useDispatch()
  const [query, setQuery] = useState('')
  const [initialsMounted, setInitialsMounted] = useState(false);
  // const [category, setCategory] = useState('')
  const [loadMoreTrigger, triggerLoadMore] = useState(Date.now())
  const [loaded, setLoaded] = useState(false)
  const [state, setState] = useState({
    companies: [],
    cursor: 0,
    end: false,
    total: 0,
  })
  const qs = useQuery();
  const category = qs.get('category') || '';
  const initialSearch = qs.get('query') || '';

  const handleLoadMore = () => {
    triggerLoadMore(Date.now())
  }

  useEffect(() => {
    console.log("Page reloaded")
    dispatch(getCategoriesAsync());
  }, [])

  useEffect(() => {
    if (initialsMounted) return
    setQuery(initialSearch)
    setInitialsMounted(true)
  }, [initialSearch])

  useEffect(() => {
    dispatch(getCompaniesAsync(query, category, 0, (data) => {
      console.log(data)
      setState({
        ...data,
        end: data.companies.length === 0 || data.companies.length === data.total
      });
      setLoaded(true);
    }))
  }, [query, category])

  useEffect(() => {
    if (!loaded) return
    dispatch(getCompaniesAsync(query, category, state.cursor, (data) => {
      setState({
        ...data,
        companies: [
          ...state.companies,
          ...data.companies,
        ],
        end: data.companies.length === 0,
      })
    }))
  }, [loadMoreTrigger])

  return (
    <>
      <StickyHeader />
      <main>
        <CompaniesSearch query={query} setQuery={setQuery} state={state} category={category} />
        {/* <CompaniesFilter /> */}
        <CompaniesResults state={state} handleLoadMore={handleLoadMore} />
      </main>
      <Footer />
    </>
  );
}

export default CompaniesListing;
